import React from 'react';
import SettingsSidebar from '../SettingsSidebar/SettingsSidebar';

export default function SettingsWrapper({ children }) {
  return (
    <div className="lg:flex lg:gap-x-16">
      <SettingsSidebar />
      <div className="px-4 py-16 sm:px-6 lg:flex-auto lg:px-0 lg:py-0">
        <div className="mx-auto max-w-2xl space-y-16 sm:space-y-20 lg:mx-0 lg:max-w-none">
          {children}
        </div>
      </div>
    </div>
  );
}
